import React from 'react';
import { getLocator, isSafariBrowser } from '@tcp/core/src/utils';
import PropTypes from 'prop-types';
import Modal from '../../../../common/molecules/Modal';
import { modalStyles } from '../../../../common/organisms/QuickViewModal/styles/QuickViewModalModalAnimation.style';
import withStyles from '../../../../common/hoc/withStyles';
import BIAProductTileView from './BIAProductTile.view';
import styles from '../styles/BuyitAgainDrawer.style';
import Button from '../../../../common/atoms/Button';
import PLPSkeleton from '../../../../common/atoms/PLPSkeleton';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import BuyItAgainBagPageLabels, { PRODUCT_DETAIL_LABELS } from '../views/BuyItAgainBagPage.labels';

const BuyItAgainDrawer = (props) => {
  const PdpLabels = getLabelFromCopyOrFromTranslation(
    PRODUCT_DETAIL_LABELS,
    BuyItAgainBagPageLabels
  );
  const {
    isShopAllDrawerOpen,
    openShopAllDrawer,
    className,
    getMoreBiaDrawerProducts,
    totalProductsCount,
    initialProductLoaded,
    biaDrawerProducts,
    isLoadingBIAPageProducts,
  } = props;
  const onCloseClick = () => {
    openShopAllDrawer(false);
  };
  const modalHeadingNewQV = {
    className: 'modal-heading',
  };
  const isSafari = isSafariBrowser();
  return (
    <div>
      <Modal
        fixedWidth
        isOpen={isShopAllDrawerOpen}
        onRequestClose={() => {
          onCloseClick();
        }}
        heading={'Buy It Again'}
        headingAlign="center"
        overlayClassName="TCPModal__Overlay"
        dataLocator={getLocator('quick_view_modal')}
        dataLocatorHeader={getLocator('quick_view_add_to_bag_header')}
        closeIconDataLocator={getLocator('quick_view_icon_btn')}
        className={`TCPModal__Content, ${className}`}
        inheritedStyles={modalStyles}
        innerContentClassName={`atb-innerContent`}
        headingFontWeight="bold"
        headingFontFamily="secondary"
        isSafari={isSafari}
        stickyHeader
        fontSize="fs22"
        headingStyle={modalHeadingNewQV}
      >
        {
          <div className="outerCont">
            {biaDrawerProducts?.map((item, index) => (
              <BIAProductTileView
                product={item}
                {...props}
                index={index}
                amountOfBIAProducts={biaDrawerProducts?.length}
                fromBIADrawer
              />
            ))}
          </div>
        }
        {totalProductsCount !== initialProductLoaded && (
          <div className="drawer-footer">
            <Button
              className="bia-view-more"
              buttonVariation="fixed-width"
              dataLocator={getLocator('global_addtocart_Button')}
              onClick={() => {
                getMoreBiaDrawerProducts();
              }}
            >
              {renderLabel(PdpLabels?.lbl_view_more, 'lbl_view_more')}
            </Button>
          </div>
        )}
        {isLoadingBIAPageProducts && <PLPSkeleton col={4} />}
      </Modal>
    </div>
  );
};

BuyItAgainDrawer.propTypes = {
  className: PropTypes.string,
  isShopAllDrawerOpen: PropTypes.bool,
  openShopAllDrawer: PropTypes.func,
  onQuickViewOpenClick: PropTypes.func,
  PdpLabels: PropTypes.shape,
  getBIADrawerproducts: PropTypes.func,
  totalProductsCount: PropTypes.number,
  initialProductLoaded: PropTypes.number,
  getMoreBiaDrawerProducts: PropTypes.func,
  biaDrawerProducts: PropTypes.shape([]),
  isLoadingBIAPageProducts: PropTypes.bool,
};

BuyItAgainDrawer.defaultProps = {
  className: 'clas',
  isShopAllDrawerOpen: false,
  openShopAllDrawer: () => {},
  onQuickViewOpenClick: () => {},
  PdpLabels: {},
  getMoreBiaDrawerProducts: () => {},
  getBIADrawerproducts: () => {},
  totalProductsCount: 2,
  initialProductLoaded: 3,
  biaDrawerProducts: [],
  isLoadingBIAPageProducts: false,
};

export default withStyles(BuyItAgainDrawer, styles);
export { BuyItAgainDrawer as BuyItAgainDrawerVanilla };
